const recordAudioPlayed = (element: HTMLElement, file_id: string, order_item_id: string, order_id: string) => {
  if (!element.getAttribute('data-played')) {
    fetch('/apps/downloads/audio_plays/' + file_id, {
      method: 'post',
      body: JSON.stringify({ order_item_id: order_item_id, order_id: order_id }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
    element.setAttribute('data-played', 'true')
  }
}

export const initializeAudio = (element: HTMLAudioElement) => {
  const file_id = element.getAttribute('data-file-id')
  const order_item_id = element.getAttribute('data-item-id')
  const order_id = element.getAttribute('data-order-id')
  if (file_id && order_id && order_item_id) {
    element.addEventListener('play', function () {
      recordAudioPlayed(element, file_id, order_item_id, order_id)
    })
  }
}

export const initializeAudios = (parent?: HTMLElement) => {
  const scope = parent || document

  scope.querySelectorAll<HTMLAudioElement>('audio.sky-pilot-audio').forEach((el) => {
    initializeAudio(el)
  })
}
